/**
 * Created by Jerker Nord on 2019-11-22.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite, TweenLite} from "gsap";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BonusBunniesSpineSymbol} from "../../symbols/BonusBunniesSpineSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";

export class BonusBunniesBonusWildAttentionView extends BaseView {

    private _layer:ScalableLayer;
    private _bunnieSpine01:BonusBunniesSpineSymbol;
    private _bunnieSpine02:BonusBunniesSpineSymbol;
    private _bunnieSpine03:BonusBunniesSpineSymbol;
    private _bunnieSpines:BonusBunniesSpineSymbol[];
    private _wildAnimation01:BonusBunniesSpineSymbol;
    private _wildAnimation02:BonusBunniesSpineSymbol;
    private _wildAnimation03:BonusBunniesSpineSymbol;
    private _wildAnimations:BonusBunniesSpineSymbol[];
    private _wildLanded:boolean = false;
    private _wildLandedReel:number = 4;
    private _bunnieLanded:boolean = false;

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.BASE_FEATURE.name);
        this._layer.addChild(this);
        this._bunnieSpines = [];
        this._wildAnimations = [];
    }

    protected initAnimations():void {
        this._wildAnimation01 = new BonusBunniesSpineSymbol(GameResources.getSpineAsset("spineWild"));
        this._wildAnimation01.visible = false;
        this._wildAnimations.push(this._wildAnimation01);
        this.addChild(this._wildAnimation01);
        this._wildAnimation02 = new BonusBunniesSpineSymbol(GameResources.getSpineAsset("spineWild"));
        this._wildAnimation02.visible = false;
        this._wildAnimations.push(this._wildAnimation02);
        this.addChild(this._wildAnimation02);
        this._wildAnimation03 = new BonusBunniesSpineSymbol(GameResources.getSpineAsset("spineWild"));
        this._wildAnimation03.visible = false;
        this._wildAnimations.push(this._wildAnimation03);
        this.addChild(this._wildAnimation03);

        this._bunnieSpine01 = new BonusBunniesSpineSymbol(GameResources.getSpineAsset("spineBunny"));
        this._bunnieSpine01.visible = false;
        this._bunnieSpines.push(this._bunnieSpine01);
        this.addChild(this._bunnieSpine01);
        this._bunnieSpine02 = new BonusBunniesSpineSymbol(GameResources.getSpineAsset("spineBunny"));
        this._bunnieSpine02.visible = false;
        this._bunnieSpines.push(this._bunnieSpine02);
        this.addChild(this._bunnieSpine02);
        this._bunnieSpine03 = new BonusBunniesSpineSymbol(GameResources.getSpineAsset("spineBunny"));
        this._bunnieSpine03.visible = false;
        this._bunnieSpines.push(this._bunnieSpine03);
        this.addChild(this._bunnieSpine03);
    }

    public getRowJumpingBunnieTL(startReel:number, startRow:number, targetRow:number):TimelineLite {
        const jumpingTL:TimelineLite = new TimelineLite();
        //Stupid strict coding needs bunnieSymbol to be set to something
        let bunnieSymbol:BonusBunniesSpineSymbol = this._bunnieSpines[0];
        for(let i:number = 0; i < this._bunnieSpines.length; i++) {
            if(this._bunnieSpines[i].originalSymPosition.x == startReel && this._bunnieSpines[i].originalSymPosition.y == startRow) {
                bunnieSymbol = this._bunnieSpines[i];
                break;
            }
        }

        if(targetRow > bunnieSymbol.currentSymPosition.y) {
            // Jump down
            const steps:number = (targetRow - bunnieSymbol.currentSymPosition.y);
            const jumps:number = Math.floor(Helper.getSymbolPositions(0, targetRow)[1] - Helper.getSymbolPositions(0, bunnieSymbol.currentSymPosition.y)[1]) / steps;
            for(let i:number = 0; i < steps; i++) {
                jumpingTL.add([
                    new TweenLite(bunnieSymbol.position, 0.4, {
                        y : Helper.getSymbolPositions(0, bunnieSymbol.currentSymPosition.y)[1] + (jumps * (i + 1))
                    }),
                    () => bunnieSymbol.setSymbolState("jump_V", 0),
                    () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BUNNY_JUMP)
                ]);
            }
            bunnieSymbol.currentSymPosition.y = targetRow;
        } else {
            //Jump up
            const steps:number = (bunnieSymbol.currentSymPosition.y - targetRow);
            const jumps:number = Math.floor(Helper.getSymbolPositions(0, bunnieSymbol.currentSymPosition.y)[1] - Helper.getSymbolPositions(0, targetRow)[1]) / steps;
            for(let i:number = 0; i < steps; i++) {
                jumpingTL.add([
                    new TweenLite(bunnieSymbol.position, 0.4, {
                        y : Helper.getSymbolPositions(0, bunnieSymbol.currentSymPosition.y)[1] - (jumps * (i + 1))
                    }),
                    () => bunnieSymbol.setSymbolState("jump_V", 0),
                    () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BUNNY_JUMP)
                ]);
            }
            bunnieSymbol.currentSymPosition.y = targetRow;
        }
        jumpingTL.add(() => bunnieSymbol.currentSymPosition.y = targetRow);
        return jumpingTL;
    }

    public getReelJumpingBunnieTL(startReel:number, startRow:number, targetReel:number):TimelineLite {
        const jumpingTL:TimelineLite = new TimelineLite();
        let bunnieSymbol:BonusBunniesSpineSymbol = this._bunnieSpines[0];
        //Getting correct Bunnie spine
        for(let i:number = 0; i < this._bunnieSpines.length; i++) {
            if(this._bunnieSpines[i].originalSymPosition.x == startReel && this._bunnieSpines[i].originalSymPosition.y == startRow) {
                bunnieSymbol = this._bunnieSpines[i];
                break;
            }
        }

        // Jump to the right or to the left?
        if(targetReel > bunnieSymbol.currentSymPosition.x) {
            //Jump to the right
            const steps:number = (targetReel - bunnieSymbol.currentSymPosition.x);
            const jumps:number = Math.floor(Helper.getSymbolPositions(targetReel, 0)[0] - Helper.getSymbolPositions(bunnieSymbol.currentSymPosition.x, 0)[0]) / steps;
            jumpingTL.add(() => bunnieSymbol.scale.x = 1);
            jumpingTL.add([
                () => bunnieSymbol.setSymbolState("jump_V", steps),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BUNNY_JUMP)
            ]);
            for(let i:number = 0; i < steps; i++) {
                let xValue:number = Math.floor(Helper.getSymbolPositions(bunnieSymbol.currentSymPosition.x, 0)[0] + (jumps * (i + 1)));
                jumpingTL.add([
                    new TweenLite(bunnieSymbol.position, 0.4, {
                        x : xValue
                    }),
                    () => bunnieSymbol.setSymbolState("jump_V", 0),
                    () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BUNNY_JUMP)
                ]);
            }
            bunnieSymbol.currentSymPosition.x = targetReel;
        } else {
            //Jump to the left
            const steps:number = (bunnieSymbol.currentSymPosition.x - targetReel);
            const jumps:number = Math.floor(Helper.getSymbolPositions(bunnieSymbol.currentSymPosition.x, 0)[0] - Helper.getSymbolPositions(targetReel, 0)[0]) / steps;
            jumpingTL.add(() => bunnieSymbol.scale.x = -1);
            for(let i:number = 0; i < steps; i++) {
                let xValue:number = Math.floor(Helper.getSymbolPositions(bunnieSymbol.currentSymPosition.x, 0)[0] - (jumps * (i + 1)));
                jumpingTL.add([
                    new TweenLite(bunnieSymbol.position, 0.4, {
                        x : xValue
                    }),
                    () => bunnieSymbol.setSymbolState("jump_V", 0),
                    () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BUNNY_JUMP)
                ]);

            }
            bunnieSymbol.currentSymPosition.x = targetReel;
        }
        jumpingTL.add(() => this.setCurrentSymPosition(bunnieSymbol, targetReel));
        return jumpingTL;
    }

    private setCurrentSymPosition(bunnieSymbol:BonusBunniesSpineSymbol, targetReel:number):void {
        bunnieSymbol.currentSymPosition.x = targetReel;
    }

    public activateHideBunnieAnimation(reel:number, row:number):void {
        const wonBGBunnieTL:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < this._bunnieSpines.length; i++) {
            if(this._bunnieSpines[i].originalSymPosition.x == reel && this._bunnieSpines[i].originalSymPosition.y == row) {
                wonBGBunnieTL.add([
                    () => this._bunnieSpines[i].setSymbolState("wonBG", 0),
                    () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BUNNY_LAUGH)
                ]);
                break;
            }
        }
        wonBGBunnieTL.add(() => this.resetAndHideBunnie(reel, row), "+=2.8");
    }

    public activateLandBunnieAnimation(reel:number, row:number):void {
        /*
        happy
        idle
        jump_V
        land
        stand
         */
        this._bunnieLanded = true;
        for(let i:number = 0; i < this._bunnieSpines.length; i++) {
            if(this._bunnieSpines[i].visible == false) {
                this._bunnieSpines[i].setStartPosition(reel, row);
                if(this._wildLanded == true) {
                    if(this._wildLandedReel < reel) {
                        this._bunnieSpines[i].setSymbolState("happyL");
                        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_SEES_WILD);
                    } else {
                        this._bunnieSpines[i].setSymbolState("happy");
                        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_SEES_WILD);
                    }
                } else {
                    this._bunnieSpines[i].setSymbolState("land");
                }
                this._bunnieSpines[i].updateTransform();
                this._bunnieSpines[i].visible = true;
                Reels.getSymbol(reel, row)!.setVisibility(false);
                break;
            }
        }
    }

    public activateLandWildAnimation(reel:number, row:number, playLand:boolean):void {
        this._wildLanded = true;
        if(reel < this._wildLandedReel) {
            this._wildLandedReel = reel;
        }
        for(let i:number = 0; i < this._wildAnimations.length; i++) {
            if(this._wildAnimations[i].visible == false) {
                const newWildTL:TimelineLite = new TimelineLite();
                newWildTL.add(() => this._wildAnimations[i].setStartPosition(reel, row));
                newWildTL.add(() => this._wildAnimations[i].updateTransform());
                newWildTL.add(() => this._wildAnimations[i].visible = true);
                newWildTL.add(() => Reels.getSymbol(reel, row)!.visible = false);
                newWildTL.add(() => this._wildAnimations[i].originalSymPosition = new PIXI.Point(reel, row));
                if(playLand == true) {
                    newWildTL.add(() => this._wildAnimations[i].setSymbolState("land"));
                }
                newWildTL.add(() => this._wildAnimations[i].setSymbolState("idle"));
                break;
            }
        }
        this.setAllActiveBunniesToHappy();
    }

    public changeWildState(reel:number, row:number, newState:string):void {
        for(let i:number = 0; i < this._wildAnimations.length; i++) {
            if(this._wildAnimations[i].visible == true) {
                if(this._wildAnimations[i].originalSymPosition.x == reel && this._wildAnimations[i].originalSymPosition.y == row) {
                    this._wildAnimations[i].setSymbolState(newState);
                }
            }
        }
    }

    private setAllActiveBunniesToHappy():void {
        let soundPlayed:boolean = false;
        for(let i:number = 0; i < this._bunnieSpines.length; i++) {
            if(this._bunnieSpines[i].visible == true) {
                if(soundPlayed == false) {
                    soundPlayed = true;
                    SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_SEES_WILD);
                }
                this._bunnieSpines[i].setSymbolState("happy");
            }
        }
    }

    public resetAndHideBunnie(reel:number, row:number):void {
        for(let i:number = 0; i < this._bunnieSpines.length; i++) {
            if(this._bunnieSpines[i].originalSymPosition.x == reel && this._bunnieSpines[i].originalSymPosition.y == row) {
                this._bunnieSpines[i].visible = false;
                this._bunnieSpines[i].killStateTL();
                this._bunnieSpines[i].scale.x = 1;
                Reels.moveSymbolToTop(reel, row);
                Reels.getSymbol(reel, row)!.setVisibility(true);
                break;
            }
        }
    }

    public resetBunnieAnimations():void {
        for(let i:number = 0; i < this._bunnieSpines.length; i++) {
            this._bunnieSpines[i].visible = false;
            this._bunnieSpines[i].killStateTL();
            this._bunnieSpines[i].scale.x = 1;
            Reels.moveSymbolToTop(this._bunnieSpines[i].originalSymPosition.x, this._bunnieSpines[i].originalSymPosition.y);
            Reels.getSymbol(this._bunnieSpines[i].originalSymPosition.x, this._bunnieSpines[i].originalSymPosition.y)!.setVisibility(true);
        }
        this._bunnieLanded = false;
    }

    public abort():void {
        this.resetBunnieAnimations();
        this.resetAllWildAnimations();
    }

    public resetBunnieNearWinAnimations():void {
        for(let i:number = 0; i < this._bunnieSpines.length; i++) {
            if(this._bunnieSpines[i].symbolState == "land") {
                this._bunnieSpines[i].visible = false;
                this._bunnieSpines[i].killStateTL();
                this._bunnieSpines[i].scale.x = 1;
                Reels.moveSymbolToTop(this._bunnieSpines[i].originalSymPosition.x, this._bunnieSpines[i].originalSymPosition.y)
                Reels.getSymbol(this._bunnieSpines[i].originalSymPosition.x, this._bunnieSpines[i].originalSymPosition.y)!.setVisibility(true);
            }
        }
        this._bunnieLanded = false;
    }

    public resetWildAnimation(reel:number, row:number):void {
        for(let i:number = 0; i < this._wildAnimations.length; i++) {
            if(this._wildAnimations[i].originalSymPosition.x == reel && this._wildAnimations[i].originalSymPosition.y == row) {
                this._wildAnimations[i].visible = false;
                Reels.getSymbol(this._wildAnimations[i].originalSymPosition.x, this._wildAnimations[i].originalSymPosition.y)!.visible = true;
                break;
            }
        }
    }

    public resetAllWildAnimations():void {
        for(let i:number = 0; i < this._wildAnimations.length; i++) {
            if(this._wildAnimations[i].visible == true) {
                this._wildAnimations[i].visible = false;
                this._bunnieSpines[i].killStateTL();
                this._bunnieSpines[i].scale.x = 1;
                Reels.getSymbol(this._wildAnimations[i].originalSymPosition.x, this._wildAnimations[i].originalSymPosition.y)!.visible = true;
            }
        }
        this._wildLanded = false;
        this._wildLandedReel = 4;
    }

    get wildLanded():boolean {
        return this._wildLanded;
    }

    get bunnieLanded():boolean {
        return this._bunnieLanded;
    }
}